import { render, staticRenderFns } from "./salemankpi.vue?vue&type=template&id=11ef1b22&scoped=true"
import script from "./salemankpi.vue?vue&type=script&lang=js"
export * from "./salemankpi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11ef1b22",
  null
  
)

export default component.exports